{
  "contacts": {
    "all_contacts": "All Contacts",
    "all_employees": "All Employees",
    "company_type": "Company type",
    "relationship_partner": "Relationship partner",
    "company_hierarchy": "Company Hierarchy",
    "known_by": "Known by",
    "consent_status": "Consent status",
    "key_activity": "Key activity",
    "results": "Results",
    "add_new_contact": {
      "continue": "Continue",
      "add_new_contact": "Add new contact",
      "success": "You've successfully created a new contact",
      "first_step_header": "Add new Contact to the person",
      "first_step_header_description": "Add a New Company Email or Personal Email to the Person and we'll create a new Contact based on that."
    }
  },
  "companies": {
    "all_companies": "All Companies"
  },
  "key_activity": {
    "slide": {
      "aria_label": "key activity slide",
      "contacts_involved": "Contacts Involved",
      "staff_involved": "Staff Involved",
      "note": "Note",
      "comments": "Comments"
    },
    "performance": {
      "current": "Current",
      "best": "Best",
      "consecutive": "Consecutive",
      "longest": "Longest",
      "weeks": "Weeks",
      "current_tooltip": "You have logged {{count}} key activities this month",
      "best_tooltip": "Your personal best: {{count}} key activities in a month",
      "consecutive_tooltip": "You've logged weekly key activities for the past {{count}} weeks",
      "longest_tooltip": "Your longest streak: {{count}} weeks"
    },
    "firm_wide": {
      "title": "Firm Wide",
      "this_month": "This Month",
      "tooltip": "Total key activities across the firm this month"
    },
    "actions": {
      "update_aria_label": "update key activity",
      "update_title": "update key activity",
      "remove_aria_label": "remove key activity",
      "remove_title": "remove key activity",
      "log_new_activity": "Log new activity"
    },
    "grid": {
      "loading_aria_label": "loading key activities",
      "load_limit_message": "There are more key activities than shown.",
      "show_less": "show less",
      "show_more": "+{{count}} more"
    },
    "filters": {
      "select_employee": "Select Employee",
      "select_month_year": "select month and year",
      "select_activity_category": "select activity category",
      "all_employees": "All",
      "basic": "Basic",
      "large": "Large"
    },
    "chart": {
      "business_development": "Business Development Activity",
      "lead_activity": "Lead Activity",
      "marketing_activity": "Marketing Activity"
    },
    "categories": {
      "business_development": "Business Development",
      "lead": "Lead",
      "marketing": "Marketing"
    }
  },
  "mobile_contact_request": {
    "objective_progress": {
      "thanks_for_update": "Thanks for the update :)"
    },
    "contact_request_page": {
      "thank_you_message": "Thank you for adding your contacts. You can close this window now.",
      "im_done": "I'm Done"
    },
    "header": {
      "instruction_text": "Please select and add your contacts you want to add to list \"{{listName}}\". Once you have added your contacts, click on \"I'm done\"."
    },
    "my_contacts": {
      "my_contacts": "My Contacts",
      "company_type": "Company type",
      "consent_status": "Consent status",
      "no_contacts_message": "There's no contact to show here"
    },
    "bulk_add": {
      "contact_list": "Contact List",
      "bulk_add_description": "Bulk add contacts to list",
      "adding_in_progress_message": "The contact is being added. Please refresh the page to see the updated list.",
      "adding_in_progress_title": "Adding Contact in Progress",
      "add_selected": "Add Selected"
    },
    "contacts_table": {
      "selected": "selected",
      "contact": "Contact",
      "company": "Company",
      "location": "Location",
      "last_interaction": "Last Interaction"
    }
  },
  "meetings": {
    "slide": {
      "aria_label": "meeting slide",
      "add_key_activity": "Add key activity",
      "contacts_involved": "Contacts Involved",
      "staff_involved": "Staff Involved",
      "companies": "Companies"
    },
    "upcoming": {
      "cancelled": "[Cancelled]",
      "with": "With:",
      "mark_as_bd_activity": "mark as bd activity",
      "no_meetings_coming_up": "There's no meetings coming up"
    },
    "recent": {
      "with": "With:",
      "mark_as_bd_activity": "mark as bd activity",
      "create_task": "Create Task",
      "create_note": "Create Note",
      "no_recent_meetings": "You haven't had a meeting for a while"
    },
    "calendar_view": {
      "all": "All",
      "select_all": "Select All",
      "tasks": "Tasks",
      "external_meetings": "External Meetings",
      "key_activities": "Key Activities",
      "task_tooltip": "task"
    },
    "contact_table": {
      "show_less": "Show less",
      "show_more": "Show more"
    },
    "key_activity": {
      "view_activity_details": "view activity details",
      "activity": "Activity",
      "type": "Type",
      "note": "Note",
      "edit_activity": "Edit activity",
      "remove": "Remove"
    }
  },
  "company_list": {
    "show_personal_info": "Show personal info",
    "close_personal_info": "Close personal info"
  },
  "reports": {
    "search_placeholder": "Search Report",
    "loading": "Loading Reports",
    "loading_report": "Loading report",
    "empty_state": "No Reports Available",
    "browser_not_supported": "Your browser does not support iframes."
  }
}
